export const valueFromTheme = (path, defaultValue) => {
    const paths = path.split('.');
    return ({theme}) => {
        try {
            let value = theme;
            for (let i = 0; i < paths.length; i++) {
                const currentPath = paths[i];
                value = value[currentPath];
            }
            return value;
        } catch (e) {
            return defaultValue;
        }
    }
};

export const valueFromPalette = (palette, defaultValue) => {
    return valueFromTheme(`palette.${palette}`, defaultValue);
};

export const primary = (defaultValue) => {
    return valueFromPalette('primary', defaultValue)
};

export const warning = (defaultValue) => {
    return valueFromPalette('warning', defaultValue)
};

export const danger = (defaultValue) => {
    return valueFromPalette('danger', defaultValue)
};

export const info = (defaultValue) => {
    return valueFromPalette('info', defaultValue)
};

export const success = (defaultValue) => {
    return valueFromPalette('success', defaultValue)
};


